import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  selectMeteorologyAgroWBSequentialMapsPeriodEnd,
  selectMeteorologyAgroWBSequentialMapsPeriodStart,
  selectMeteorologyAgroWBSequentialMapsVariable,
} from 'redux/reducers/meteorologyAgroWBSequentialMapsReducer';

export default function useMapParams() {
  const variable = useSelector(selectMeteorologyAgroWBSequentialMapsVariable);
  const startDate = useSelector(selectMeteorologyAgroWBSequentialMapsPeriodStart);
  const endDate = useSelector(selectMeteorologyAgroWBSequentialMapsPeriodEnd);

  const params = useMemo(() => {
    if (!variable || !startDate) return undefined;

    return {
      variable,
      startDate,
      endDate: endDate || startDate,
    };
  }, [variable, startDate, endDate]);

  return params;
}
